import React                  from 'react';
import CloseBtn               from 'assets/icons/Close.svg';
import UploadedFile           from 'assets/icons/Uploaded File.svg';
import { Modal }              from 'react-bootstrap';

export function ReferralDetailsModal({log, setShowLogDetailsModal, showLogDetailsModal}) {

  const doctor = log.doctor;
  const url = log.referral_letter ? log.referral_letter.styles.origin.url : '#';
  const patientInfo = [
    { title: 'Email',      value: log.patient_email },
    { title: 'Full Name',  value: log.patient_name },
    { title: 'Phone',      value: log.patient_phone_number }
  ]
  const doctorInfo = [
    { title: 'Specialty',                   value: doctor?.specialties?.map(s => s.name).join(', ') },
    { title: 'Doctor/Hospital Name',        value: [doctor?.title, doctor?.first_name, doctor?.last_name].filter(Boolean).join(' ') },
    { title: 'Note',                        value: log.note || '-' }
  ]  

  const generateInfos = (infos) => {
    const byChunks = infos.reduce((memo, value, index) => {
      if (index % 2 === 0 && index !== 0) memo.push([])
      memo[memo.length - 1].push(value)
      return memo
    }, [[]]);

    return byChunks.map((array, index) => {
      return (
        <div className="row" key={ index }>
          <div className="col">
            <p className="text-lightgrey mb-0 font-size-3">{ array[0]?.title }</p>
            <p><b>{ array[0]?.value || '-'  }</b></p>
          </div>
  
          <div className="col">
            <p className="text-lightgrey mb-0 font-size-3">{ array[1]?.title }</p>
            <p><b>{ array[1] ? (array[1]?.value || '-') : null }</b></p>
          </div>
        </div>
      )
    });
  }

  return (
    <Modal size="lg" show={showLogDetailsModal} onHide={() => setShowLogDetailsModal(false)}>
      <Modal.Header>
          <Modal.Title>Referral Details</Modal.Title>
          <button type="button" className="close" onClick={() => setShowLogDetailsModal(false)}>
          <img src={ CloseBtn } alt="modal-close" />
          </button>
      </Modal.Header>
      <Modal.Body>
          <div>
          <h6 className="mb-3">Patient Information</h6>
          {generateInfos(patientInfo)}
          </div>
          <hr />
          {generateInfos(doctorInfo)}
          <div className="row">
            <div className="col">
              <p className="text-lightgrey mb-3 font-size-3">Referral Letter (Optional)</p>
              {log.referral_letter ? (
                <a href={url} target="_blank" rel="noreferrer" className="text-danger text-decoration-none">
                  <img src={UploadedFile} alt="uploaded-file" />
                  <span>{url.substring(url.lastIndexOf('/')+1)}</span>
                </a>
              ) : 
                '-'
              }
            </div>
          </div>
      </Modal.Body>
    </Modal>
  )
}

export default ReferralDetailsModal;